export const NOT_DELIVERABLE = 'NOT_DELIVERABLE';
export const ZERO_RESULTS = 'ZERO_RESULTS';
export const NOT_DELIVERABLE_NO_PICKUP = 'NOT_DELIVERABLE_NO_PICKUP';
export const EMPTY_STRING = '';
